import type { ComponentType, FC } from "react";
import { usePropertyDocumentsQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyDocumentsQuery";
import { DetailLoader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailLoader";
import { RelatedSectionRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/RelatedSectionRedesign";
import type {
	PropertyDetail,
	PropertySectionProps,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/propertySectionRegistry";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

type Props = {
	property: PropertyDetail;
	TypeDetail: ComponentType<PropertySectionProps<PropertyDetail>>;
	currencySign: string;
	propertyId?: number;
};

export const PropertyDetailSections: FC<Props> = ({
	property,
	TypeDetail,
	currencySign,
	propertyId,
}) => {
	const { data: documents, isLoading: isDocumentsLoading } =
		usePropertyDocumentsQuery(propertyId);

	if (isDocumentsLoading) {
		return <DetailLoader />;
	}

	return (
		<>
			<TypeDetail data={property} currencySign={currencySign} />

			<RelatedSectionRedesign
				documents={documents?.data}
				related={property.related}
				itemKind={PortfolioItemKind.Property}
				propertyId={property.id}
			/>
		</>
	);
};
